import React from "react";
import cn from "classnames";
import _take from "lodash/take";
import _get from "lodash/get";
import Icon from "backpack-ui/dist/components/icon";
import MaterialIcons from "./icons";
import styles from "./styles.css";

export const getResultIcon = (type, subtype) => {
  let ResultIcon = Icon.Map;
  const icons = {
    article: MaterialIcons.Public,
    lodging: MaterialIcons.LocalHotel,
    narratives: MaterialIcons.Description,
    news: MaterialIcons.Public,
    partner_activity: MaterialIcons.LocalActivity,
    place: Icon.Pin,
    "thorntree-topic": MaterialIcons.Forum,
    video: MaterialIcons.LocalMovies,
  };

  if (icons[type]) {
    ResultIcon = icons[type];
  } else if (type === "poi") {
    const poiIcons = {
      Activities: MaterialIcons.LocalActivity,
      Attractions: MaterialIcons.PhotoCamera,
      Entertainment: MaterialIcons.LocalActivity,
      Events: Icon.Calendar,
      Hotels: MaterialIcons.LocalHotel,
      Information: Icon.Info,
      Nightlife: MaterialIcons.LocalBar,
      Restaurants: MaterialIcons.Restaurant,
      Shopping: MaterialIcons.LocalMall,
      Transportation: MaterialIcons.DirectionsTransit,
    };
    if (poiIcons[subtype]) {
      ResultIcon = poiIcons[subtype];
    }
  }

  return <ResultIcon className={styles.resultIcon} />;
};

const Results = ({ className, searchResults, searchTerm }) => {
  return (
    <ul className={cn(styles.results, className)}>
      {_take(searchResults, 5).map((result) => {
        const title = _get(result, "highlights.title") || result.title;
        const parentName =
          _get(result, "highlights.op-parent-name") || result.opParentName;
        const text = parentName ? `${title}, ${parentName}` : title;

        return (
          <li className={styles.resultItem} key={result.id}>
            <a href={result.url} className={styles.resultLink}>
              {getResultIcon(result.opType, result.opSubtype)}

              <span
                className={styles.resultTitle}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </a>
          </li>
        );
      })}

      <li className={styles.resultItem}>
        <a
          href={`https://www.lonelyplanet.com/search?q=${searchTerm}`}
          className={cn(styles.resultLink, styles.resultLinkAll)}
        >{`Show all results for “${searchTerm}”`}</a>
      </li>
    </ul>
  );
};

export default Results;
